import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-user-status1",
  "use": "icon-user-status1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-user-status1\">\n<g id=\"icon-user-status1_icon\" clip-path=\"url(#icon-user-status1_clip0_677_42880)\">\n<path id=\"icon-user-status1_Vector\" d=\"M7.99987 0.964844C4.11427 0.964844 0.964355 4.11461 0.964355 8.00007C0.964355 11.8855 4.11427 15.0353 7.99987 15.0353C11.8855 15.0353 15.0354 11.8855 15.0354 8.00007C15.0354 4.11461 11.8855 0.964844 7.99987 0.964844ZM11.0307 10.0039L10.0031 11.031L8.00023 9.0275L5.9963 11.031L4.96902 10.0039L6.97221 8.00009L4.96902 5.99658L5.9963 4.96915L7.99987 6.97264L10.0031 4.96915L11.0307 5.99658L9.02715 8.00007L11.0307 10.0039Z\" fill=\"#777777\" />\n</g>\n<defs>\n<clipPath id=\"icon-user-status1_clip0_677_42880\">\n<rect width=\"16\" height=\"16\" fill=\"white\" />\n</clipPath>\n</defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/user-status1.svg
// module id = NLH1
// module chunks = 102